module.exports = __webpack_public_path__ + "static/solution_02-3bba8baf38766f61299723667645f345.jpg";